import {
  CheckCircleIcon,
  ClockIcon,
  ExclamationCircleIcon,
  ExclamationTriangleIcon,
} from '@heroicons/react/24/solid';

interface StatusIndicatorProps {
  statusIsIncomplete?: boolean;
  statusIsLate?: boolean;
  statusIsFailed?: boolean;
  statusIsWarning?: boolean;
  statusIsOk?: boolean;
}

export const StatusIndicator = ({
  statusIsIncomplete,
  statusIsLate,
  statusIsFailed,
  statusIsWarning,
  statusIsOk,
}: StatusIndicatorProps) => {
  if (statusIsIncomplete) {
    return <ClockIcon className="w-4 h-4 text-muted-foreground/60" />;
  }

  if (statusIsLate) {
    return <ClockIcon className="w-4 h-4 text-red-500" />;
  }

  if (statusIsFailed) {
    return <ExclamationTriangleIcon className="w-4 h-4 text-red-500" />;
  }

  if (statusIsWarning) {
    return <ExclamationCircleIcon className="w-4 h-4 text-amber-500" />;
  }

  if (statusIsOk) {
    return <CheckCircleIcon className="w-4 h-4 text-green-500" />;
  }

  return null;
};
